import { useDispatch } from "react-redux";
import { push } from "connected-react-router"
import styled from 'styled-components'
import { Layout } from '../components'
// Mui
import Button from "@material-ui/core/Button"
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { useEffect, useState } from 'react';
import { db } from '../firebase';

const dateTimeToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) + ' ' + 
        ('00' + date.getHours()).slice(-2) + ':' + 
        ('00' + date.getMinutes()).slice(-2) + ':' + 
        ('00' + date.getSeconds()).slice(-2)
}
const dateToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) 
}

const OrderManager = () => {

    const dispatch = useDispatch()
    const [orders, setOrders] = useState([])
    const [showOnly, setShowOnly] = useState('')

    const FilteredTableRow = props => {
        const order = props.order
        return (
            <TableRow
                style={{cursor: 'pointer'}}
                key={order.id} hover role="checkbox" tabIndex={-1} selected={false}
                onClick={() => dispatch(push('/admin/order/dp/' + order.id))}
            >
                <TableCell align="center">{order.status}</TableCell>
                <TableCell align="left">{order.user?.lastname + " " + order.user?.firstname}</TableCell>
                <TableCell align="right">{'¥' + order.amount}</TableCell>
                <TableCell align="center">{order.created_at ? dateTimeToString(order.created_at.toDate()) : ""}</TableCell>
                <TableCell align="center">{order.shipping_date ? dateToString(order.shipping_date.toDate()) : ""}</TableCell>
            </TableRow>
        )
    }

    // 注文情報を取得
    useEffect(()=>{
        db.collectionGroup('orders').orderBy('created_at','desc').get()
          .then(snapshots=>{
                const tempOrderList = []
                snapshots.forEach(snapshot => {
                    tempOrderList.push(snapshot.data())
                })
                setOrders(tempOrderList)
          })
    },[])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>注文管理</h1>
            <div className='spacer-50' />

            <div style={{textAlign: 'center'}}>
                <Button onClick={()=>setShowOnly('')}>全て表示</Button>
                <Button onClick={()=>setShowOnly('発送待ち')}>発送待ちのみ表示</Button>
                <Button onClick={()=>setShowOnly('発送完了')}>発送完了のみ表示</Button>
            </div>
            <div className='spacer-50' />

            <Wrapper>
                
                <TableContainer>
                    <Table
                        aria-labelledby="tableTitle"
                        size={'medium'}
                        aria-label="enhanced table"
                    >
                        <TableHead>
                            <TableRow>  
                                <TableCell key={1} align={'center'} padding={'default'} sortDirection={false} >
                                    ステータス
                                </TableCell>
                                <TableCell key={3} align={'left'} padding={'default'} sortDirection={false} >
                                    購入者氏名
                                </TableCell>
                                <TableCell key={4} align={'center'} padding={'default'} sortDirection={false} >
                                    購入金額
                                </TableCell>
                                <TableCell key={5} align={'center'} padding={'default'} sortDirection={false} >
                                    購入日時
                                </TableCell>
                                <TableCell key={7} align={'center'} padding={'default'} sortDirection={false} >
                                    発送日
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {orders.length > 0 && orders.map((order,index)=>{
                                if (showOnly === '発送完了') {
                                    return order.status === '発送完了' ? <FilteredTableRow key={index} order={order} /> : false
                                } else if (showOnly === '発送待ち') {
                                    return order.status === '発送待ち' ? <FilteredTableRow key={index} order={order} /> : false
                                } else {
                                    return <FilteredTableRow key={index} order={order} />
                                }
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Wrapper>

            <div className='spacer-100' />
        </Layout>
    )
}
export default OrderManager

const Wrapper = styled.div`
    width: 960px;
    margin: 0 auto;
`